import React from "react";
import { Button, Flex, ModalV2, Text } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";

export type ClearFeedbackModalProps = {
  isOpen: boolean;
  checkName: string;
  onCancel: () => void;
  onConfirm: () => void;
};

/**
 * ClearFeedbackModal — confirms clearing feedback that has an unsent comment,
 * so a reviewer doesn't silently discard the comment by toggling the
 * thumbs-down back off.
 */
export const ClearFeedbackModal = ({
  isOpen,
  checkName,
  onCancel,
  onConfirm,
}: ClearFeedbackModalProps) => (
  <ModalV2
    data-testid="clear-feedback-modal"
    title="Clear feedback"
    show={isOpen}
    onHide={onCancel}
    size="small"
  >
    <ModalV2.Body>
      <Text variant="regular-lg">
        Are you sure you want to clear feedback for &ldquo;{checkName}&rdquo;?
      </Text>
    </ModalV2.Body>
    <ModalV2.Footer>
      <Flex gap={Sizes.MD} justifyContent="end">
        <Button variant="neutral" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            onConfirm();
            onCancel();
          }}
        >
          Clear feedback
        </Button>
      </Flex>
    </ModalV2.Footer>
  </ModalV2>
);
